import { useQuery } from "@tanstack/react-query";
import {
  CsobTokenExpirationDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_CSOB } from "../domain";

import { csobHubApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_CSOB_TOKEN_EXPIRATION = "GET_CSOB_TOKEN_EXPIRATION";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent];

const getCsobTokenExpiration = async (): Promise<CsobTokenExpirationDto> => {
  const response = await csobHubApi.csobHubControllerGetCsobTokenExpiration();

  return response.data;
};

export const useGetCsobTokenExpiration = (
  user: UserProfileDto | null,
  enable = true,
): {
  csobTokenExpiration?: CsobTokenExpirationDto;
  csobTokenExpirationEnabled: boolean;
  isPendingGetCsobTokenExpiration: boolean;
  isLoadingGetCsobTokenExpiration: boolean;
  isErrorGetCsobTokenExpiration: boolean;
} => {
  const enabled = enable && roleGuard(user, allowedRoles);
  const { data, isPending, isLoading, isError } = useQuery({
    queryKey: [DOMAIN_CSOB, ACTION_GET_CSOB_TOKEN_EXPIRATION],
    queryFn: () => getCsobTokenExpiration(),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
    retry: false,
  });

  return {
    csobTokenExpiration: data,
    csobTokenExpirationEnabled: enabled,
    isPendingGetCsobTokenExpiration: isPending,
    isLoadingGetCsobTokenExpiration: isLoading,
    isErrorGetCsobTokenExpiration: isError,
  };
};
